import React , {useState} from "react";
import "./Weather.css";
import axios from "axios";
import WeatherInfo from "./WeatherInfo.js";
import Forecast from "./Forecast.js";

export default function Weather(props){
    const [weatherData , setWeatherData] = useState({ready : false});
    const [city , setCity] = useState(props.defaultCity)
    function handleResponse(response) {
        console.log(response.data);
        setWeatherData({
            ready: true,
            temperature: response.data.temperature.current ,
            wind: response.data.wind.speed,
            city: response.data.city,
            date: new Date(response.data.time * 1000),
            humidity : response.data.temperature.humidity ,
            description : response.data.condition.description,
            icon : response.data.condition.icon
        });
    }

    function search(){
    const apiKey = "b2a5adcct04b33178913oc335f405433";
    const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
    }

    function handleSubmit(event){
        event.preventDefault();
        search()
    }

    function handleCityChange(event) {
        setCity(event.target.value)
    }

    if(weatherData.ready) {
            return(
        <div className="Weather">
        <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-9">
                        <input 
                        type="search"
                        placeholder="Enter a city"
                        className="form-control"
                        onChange={handleCityChange}
                        />
                    </div>
                    <div className="col-3">
                        <input 
                        type="submit"
                        value="search" 
                        className="btn btn-primary w-100"
                        autoFocus="on"
                        />
                    </div>
                </div>
                </form>
            <WeatherInfo data={weatherData} />
            <Forecast city={weatherData.city} />
        </div>
    )
    } else{
        search();
    return "Loading...";
    }

}